import { render } from "./LedgerSection.vue?vue&type=template&id=60c0924d&scoped=true"
import script from "./LedgerSection.vue?vue&type=script&lang=js"
export * from "./LedgerSection.vue?vue&type=script&lang=js"

import "./LedgerSection.vue?vue&type=style&index=0&id=60c0924d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c0924d"]])

export default __exports__